import React from 'react';

import PropTypes from 'prop-types';

import { CommandGroup, CommandItem, CommandSeparator } from '@/components/ui/command';

const ClearFiltersButton = ({ onClear }) => (
  <>
    <CommandSeparator />

    <CommandGroup>
      <CommandItem className="justify-center" onSelect={onClear}>
        Clear filters
      </CommandItem>
    </CommandGroup>
  </>
);

ClearFiltersButton.propTypes = {
  onClear: PropTypes.func.isRequired,
};

export default ClearFiltersButton;
